import styled from 'styled-components'

export const Caixa = styled.div.attrs({
})`
    background: #F5F0FF;   /* sem transparência: fica legível no fundo branco e no roxo */
    border: 1px solid var(--primary-color);
    border-radius: 10px;
    padding: 16px;
    margin: 0 0 24px;
`;

export const Titulo = styled.div.attrs({
})`
    color: var(--primary-color);
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 8px;
`;

export const Texto = styled.div.attrs({
})`
    color: var(--grey-color);
    font-size: 15px;
    line-height: 1.4;
    margin-top: 8px;
`;

export const Passos = styled.ol.attrs({
})`
    color: var(--grey-color);
    font-size: 15px;
    line-height: 1.4;
    margin: 8px 0 0;
    padding-left: 22px;
`;

export const Passo = styled.li.attrs({
})`
    margin-bottom: 6px;
`;

export const Pequeno = styled.div.attrs({
})`
    color: var(--grey-color);
    font-size: 13px;
    margin-top: 12px;
`;

export const Confirmacao = styled.div.attrs({
})`
    color: var(--primary-color);
    font-size: 14px;
    font-weight: bold;
    margin-top: 10px;
`;

export const CampoLink = styled.input.attrs({
})`
    width: 100%;
    margin-top: 8px;
    padding: 10px 8px;
    border: .5px solid var(--lightgrey-color);
    border-radius: 5px;
    font-size: 13px;
    color: var(--grey-color);
`;

export const Continuar = styled.button.attrs({
    type: 'button'
})`
    background: none;
    border: 0;
    padding: 0;
    margin-top: 14px;
    color: var(--primary-color);
    font-size: 14px;
    text-decoration: underline;
    cursor: pointer;
`;

// Os botões do aviso são botões de verdade (dá para chegar neles pelo teclado e pelo leitor de tela),
// com o mesmo desenho do botão do site (ui/styled: ButtonColor primary e primary outline).
export const Botao = styled.button.attrs({
    type: 'button'
})`
    width: 100%;
    height: 45px;
    margin-top: 16px;
    padding: 0 20px;
    border-radius: 5px;
    font-weight: bold;
    font-size: 15px;
    cursor: pointer;
    ${
        props => props.contorno ? `
            background: var(--white-color);
            border: 1px solid var(--primary-color);
            color: var(--primary-color);
        ` : `
            background: var(--primary-color);
            border: 0;
            color: var(--white-color);
        `
    }
`;
